// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  dataDictionaryBaseUrl: "https://datadictionary.qat.risepoint.com/",

  servicePartnerDataURL: "https://apim-qat.academicpartnerships.com/PartnerData",
  serviceWorkflowURL: "https://apim-qat.academicpartnerships.com/Workflow/",
  serviceDigitizeURL: "https://solutionssvcqat.academicpartnerships.com/apdigitizeservice/",
  serviceDataIntakeURL: "https://apim-qat.academicpartnerships.com/IntegrationPortal/",
  serviceArticlePublishURL: "https://solutionssvcqat.academicpartnerships.com/aparticlepublishservice/api/ArticlePublish",
  
  lastThirtyDaysAuditResult: 30,

  //Azure AD App Configurations
  adAauthority: 'https://login.microsoftonline.com/8720e855-7e28-49ff-a1a7-8d5e66b5659e/',
  adClientId: "d8dd61e0-4533-41c1-8324-03c3b0a501bb",
  adTenantId: "8720e855-7e28-49ff-a1a7-8d5e66b5659e",
  adPostLogoutRedirectUri: "https://solutions.qat.risepoint.com",
  adRedirectUrl: 'https://solutions.qat.risepoint.com',
  apiConfig: {
    partnerApiscope: ['api://SOL.PartnerData.API-QA/access_as_user'],
    workflowApiScope: ['api://SOL.Workflow.API-QA/access_as_user'],
    digitizeApiscope: ['api://SOL.Digitize.API-QA/access_as_user'],
    dataIntakeApiscope: ['api://AP.IntegrationPortal.API-QA/access_as_user']
  },
  NoOfDays: 30
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
  // import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
